<template>
  <div class="app-container" id="app">
    <router-view />
  </div>
</template>

<script>
import { isSafary } from '@/utils'
export default {
  mounted() {
    document.addEventListener("visibilitychange", this.handleVisiable);
  },
  methods: {
    handleVisiable: function (e) {
      if (e.target.visibilityState == "visible" && isSafary()) {
        window.location.reload()
      }
    },
  },
};
</script>

<style lang="less">
@import "~@/assets/less/global.less";

html,
body {
  height: 100%;
  box-sizing: border-box;
}

.app-container {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
}
</style>
